import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInvoiceAccountingDocumentChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.998 11h6.003M5.998 7.998H9"
    />
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.499 17.002c-.829 0-1.5-.672-1.5-1.5v0c0-.829.671-1.5 1.5-1.501v0c.828 0 1.5.672 1.5 1.5v0c0 .83-.672 1.5-1.5 1.501M12.5 17.252h2.501v3.752h-2.5a.5.5 0 0 1-.501-.5v-2.752a.5.5 0 0 1 .5-.5M15.501 13.001h2.001a.5.5 0 0 1 .5.5v7.503h-3.001v-7.503a.5.5 0 0 1 .5-.5M18.503 15.252h2.001a.5.5 0 0 1 .5.5v4.752a.5.5 0 0 1-.5.5h-2.501v-5.252a.5.5 0 0 1 .5-.5"
      clipRule="evenodd"
    />
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.999 21.004H4.997a2 2 0 0 1-2-2.001V4.997a2 2 0 0 1 2-2h8.175a2 2 0 0 1 1.415.585l2.83 2.83a2 2 0 0 1 .585 1.415v2.172"
    />
  </svg>
);
export default SvgInvoiceAccountingDocumentChart;
